import { connect, ConnectedProps } from "react-redux";

import { IStoreState } from "../../../../reducers/types";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getPetsCount,
  getUntilDate,
} from "../../../search/reducer";
import { WishlistManagementModal } from "./component";
import { FavoritesEntryType } from "redmond";
import { History } from "history";

interface IStateProps {
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number[];
  petsCount: number;
}

interface IOwnProps {
  history: History;
  entryType?: FavoritesEntryType;
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildren(state),
  petsCount: getPetsCount(state),
});

interface IDispatchProps {}

const mapDispatchToProps = {};

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type WishlistManagementModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistManagementModal = connector(
  WishlistManagementModal
);
